import type { AnyRouter, ParsedLocation } from '@tanstack/react-router'

declare module '@tanstack/react-router' {
  interface StaticDataRouteOption {
    scrollPage?: boolean
  }
}

function scrollPage(router: AnyRouter, location: ParsedLocation) {
  const page = router.matchRoutes(location).findLast((match) => match.staticData.scrollPage)
  return page?.pathname ?? location.pathname
}

export function setupPlannerScrollReset(router: AnyRouter) {
  return router.subscribe('onRendered', ({ pathChanged, fromLocation, toLocation }) => {
    if (
      !pathChanged ||
      toLocation.hash ||
      (fromLocation && scrollPage(router, fromLocation) === scrollPage(router, toLocation))
    ) {
      return
    }

    document.querySelector<HTMLElement>('#main-content')?.scrollTo({ top: 0, left: 0 })
  })
}
